module.exports = __webpack_public_path__ + "img/download-step1.64530f6f.png";